export default __webpack_public_path__ + "static/media/k1.15b3d037.svg";